import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';
import { SketchPicker } from 'react-color';

const ListaTL = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista8" id="miLista8" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>Aceite</option>
        <option>Grasa</option>
        <option>Otro</option>
      </select>
    </div>
  )
};

const ListaTG = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista1" id="miLista1" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>ISO</option>
        <option>SAE</option>
        <option>NLGI</option>
      </select>
    </div>
  )
};

const ListaCT = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista2" id="miLista2" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>BLANCO</option>
        <option>NEGRO</option>
      </select>
    </div>
  )
};

const ListaS = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista5" id="miLista5" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>AUTOMOTRIZ</option>
        <option>INDUSTRIAL</option>
      </select>
    </div>
  )
};
const ListaA = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista6" id="miLista6" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>ENGRANAJES AUTOMOTRICES</option>
        <option>MOTORES COMBUSTION INTERNA</option>
      </select>
    </div>
  )
};

const ListaC = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista3" id="miLista3" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>MONOGRADO</option>
        <option>MULTIGRADO</option>
      </select>
    </div>
  )
};

const ListaApi = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista4" id="miLista4" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>SL</option>
        <option>SM</option>
        <option>SN</option> 
        <option>CH-4</option>
        <option>CI-4</option>
        <option>CJ-4</option> 
        <option>CK-4</option>
        <option>FA-4</option>
        <option>FB</option>   
        <option>FC</option>   
        <option>FD</option>   
        <option>TC-W1</option>   
        <option>TC-W2</option>   
        <option>TC-W3</option>
        <option>MA</option>   
        <option>MA-1</option>   
        <option>MA-2</option>    
        <option>MB</option>    
      </select>
    </div>
  )
};
const ListaApi2 = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista7" id="miLista7" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>GL-4</option>
        <option>GL-5</option>
        <option>MT-1</option>  
        <option>MIL-PRF-2105E</option>  
        <option>SAE J 2360</option>  
        <option>Dexron IV</option>
        <option>Mercon V</option>   
        <option>C-A</option>   
        <option>World Spec</option>    
        <option>Volth</option>          </select>
    </div>
  )
};
class AddGrado2 extends React.Component {

render () {
  let color="#fff"
  if (this.props.args.color){
    color=this.props.args.color
  }

return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Grado nuevo
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.props.handleSubmit(ev, this.props.args)}>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={this.props.styles.label}>Tipo de lubricante</label>
                  <ListaTL styles={this.props.styles} handleLista={this.props.handleLista} />
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>Tipo de grado</label>
                  <ListaTG styles={this.props.styles} handleLista={this.props.handleLista1} />
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>Descripción</label>
                  <Form.Input autoComplete="off" name="descrGrado" id="descrGrado" onChange={this.props.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrGrado'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>                
                {this.props.args.tipoLub==='Aceite' &&
                <div>
                  <Form.Field>
                    <label style={this.props.styles.label}>Sector</label>
                    <ListaS styles={this.props.styles} handleLista={this.props.handleLista5} />
                  </Form.Field>
                  {this.props.args.sector==='AUTOMOTRIZ' &&
                  <div>
                    <Form.Field>
                      <label style={this.props.styles.label}>Aplicación SAE</label>
                      <ListaA styles={this.props.styles} handleLista={this.props.handleLista6} />
                    </Form.Field>
                    <Form.Field>
                      <label style={this.props.styles.label}>Categoría SAE</label>
                      <ListaC styles={this.props.styles} handleLista={this.props.handleLista3} />
                    </Form.Field>
                    {this.props.args.aplicacionSAE==='MOTORES COMBUSTION INTERNA' &&
                    <div>
                      <Form.Field>
                        <label style={this.props.styles.label}>Api SAE</label>
                        <ListaApi styles={this.props.styles} handleLista={this.props.handleLista4} />
                      </Form.Field>
                    </div>
                    }
                    {this.props.args.aplicacionSAE==='ENGRANAJES AUTOMOTRICES' &&
                    <div>
                      <Form.Field>
                        <label style={this.props.styles.label}>Api SAE</label>
                        <ListaApi2 styles={this.props.styles} handleLista={this.props.handleLista7} />
                      </Form.Field>
                    </div>
                    }                  
                  </div>
                  }
                </div>
                }
                <Form.Field>
                  <label style={this.props.styles.label}>Color</label>
                  <SketchPicker
                    color={color}
                    onChangeComplete={ this.props.handleColor }
                  />                                                                
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>Color de texto</label>
                  <ListaCT styles={this.props.styles} handleLista={this.props.handleLista2} />
                </Form.Field>                
                <Button style={this.props.styles.confirmar} type='submit' fluid>
                  AGREGAR
                </Button>

                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
  }
}

export default AddGrado2
